module.exports = __webpack_public_path__ + "static/img/api4.3056b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/api4.png
// module id = YbVq
// module chunks = 1